import React from 'react';
import GoogleAnalytics from 'react-ga';
import config from 'util/config.js';
import { isString, startCase, isObject, debounce} from 'lodash';
import { createAction } from 'redux-actions'
import { isFunction } from 'util';

//https://github.com/ReactTraining/react-router/issues/4278
GoogleAnalytics.initialize(config.gaTrackingId);


// Direct Logging Wrappers
export const trackPage = (page) => {
  GoogleAnalytics.set({ page });
  GoogleAnalytics.pageview(page);
};

const defaults = {
  category:'Custom Shop',
  action: 'Interactive'
}
export const trackEvent = (data) => {
  if (!isObject(data)) { data = { label: data };}
  data = Object.assign({}, defaults, data);
  GoogleAnalytics.event(data);
}

export const trackEventOutbound = (data, callback) => {
  if (!isObject(data)) { data = { label: data };}
  data = Object.assign({}, defaults, data);
  GoogleAnalytics.outboundLink(data, callback);
}


//--------------------------------

// Helper to track events on clicks
// usage: onClick = { trackedClickEvent("event label", () => actualClickBehavior)}
// or: onClick = { trackedClickEvent({ analyticsData }, () => actualClickBehavior)}
export const trackedClickEvent = (analyticsData, onClickFcn) => {
  return function(){ 
    trackEvent(analyticsData);
    onClickFcn(arguments) ;
  }
}

// export const trackEventOutbound = (analyticsData, callback) => {
//   GoogleAnalytics.event({ category, action, label });
// } 

//--------------------------------

// Helper to track a Redux action
// analytics data can be a string -- the label of the event (using default category and action)
// or an object with data to pass directly to trackEvent {category, action, label}
// or an object with a function and optional debounce delay {analyticsDataFcn:(action)=>makeLabel(action), debounce:300}
// or null, in which case the action type is cleaned up and logged as the label (using default category and action)
export const createTrackedAction = (type, payload, analyticsData) =>{
  if (!analyticsData) { analyticsData = {}; } //Trigger automatic labeling logic
  return createAction(type, payload, () => { return { eventTracking: analyticsData }; });
}

// Automatically clean up Action Type strings
function cleanActionType(type){
  return startCase(type.replace("sc/customize/", "").toLowerCase()); 
}

// Middleware for automatically tracking redux events created with createTrackedAction
// Injected in App.js. Looks at all Redux Actions and logs all events with eventTracking metadata object
var debouncedTracking = {}; 
export const EventAnalyticsMiddleware = store => next => action => {
    try{ 
    if (action.meta && action.meta.eventTracking){ 
      var trackData = null;
      var actionData = action.meta.eventTracking;
      if (isFunction(actionData.analyticsDataFcn)) {
        var state = store.getState();
        trackData = actionData.analyticsDataFcn(action, state.customize); 
      }
      else if (!isString(actionData) && !actionData.label) { trackData = cleanActionType(action.type); }

      if (trackData){ 
        // This is not how debouncing usually works, but our function is in another castle and redux makes this weird.
        if (actionData.debounce){
          var debounced = debounce(() => trackEvent(trackData), actionData.debounce); 
          debounced(); 
          debouncedTracking[action.type] && debouncedTracking[action.type].cancel(); //cancel old debounced fcn
          debouncedTracking[action.type] = debounced; //save new one so we can cancel it later
        }else{ 
          trackEvent(trackData); 
        }
      }
    }
    }catch(e){
      if (!config.isProduction){ throw e;} 
    }
    return next(action); //keep processing
}

//--------------------------------

// Wraps all Route targets to automatically log page views 
export const AnalyticsPageTracker= (WrappedComponent) => { 
  const AnalyticsPageTracker = (props) => {
    const page = props.location.pathname;
    trackPage(page);

    return (
      <WrappedComponent {...props} />
    );
  };

  return AnalyticsPageTracker;
}
